import { z } from 'zod';
import { Subtitle2 } from 'ui/theme';
import { useFormContext, useFormState } from 'react-hook-form';
import { useStartNodeContext } from '../../StartNodeEditor.context';
import { RECUR_DAYS_RANGE, SCHEDULE_RECUR_DAYS_TEST_ID } from './Scheduler.constants';
import { SchedulerFormStateValues } from './Scheduler.types';
import { ErrorText, RecurrenceFrequencyInputField } from './SchedulerForm.styled';

export const RecurDays = () => {
  const { isReadOnly } = useStartNodeContext();
  const { watch, setValue, register } = useFormContext();
  const recurDays = watch('recurDays');

  const { errors } = useFormState<SchedulerFormStateValues>();
  const { recurDays: recurDaysError } = errors;

  return (
    <div>
      <Subtitle2>Re-run every</Subtitle2>
      <RecurrenceFrequencyInputField
        data-test={SCHEDULE_RECUR_DAYS_TEST_ID}
        Suffix={<div>{parseInt(recurDays, 10) === 1 ? 'day' : 'days'}</div>}
        type="number"
        isDisabled={isReadOnly}
        isReadOnly={isReadOnly}
        {...register('recurDays', {
          onBlur: () => {
            if (recurDaysError?.type === z.ZodIssueCode.too_small)
              setValue('recurDays', RECUR_DAYS_RANGE.min);
            if (recurDaysError?.type === z.ZodIssueCode.too_big)
              setValue('recurDays', RECUR_DAYS_RANGE.max);
          },
        })}
      />
      {recurDaysError?.message && <ErrorText>{recurDaysError.message}</ErrorText>}
    </div>
  );
};
